/**
 * The FFZ Add-On Pack — FrankerFaceZ add-ons for Twitch
 *
 * Exposes a single static resource — `chrome/script.js` — scoped to `*.twitch.tv`.
 * Detectable only from Twitch, where it runs, via one fetch.
 *
 * Manifest verified against version 3.1.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'aiimboljphncldaakcnapfolgnjonlea';

export const ffzAddonPack: ExtensionDefinition = {
  id: ID,
  name: 'The FFZ Add-On Pack',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  requiredOrigin: 'https://www.twitch.tv',
  notes:
    'Single static WAR (chrome/script.js) scoped to *.twitch.tv, so only Twitch can ' +
    'detect it. One fetch there is conclusive.',
  signals: [
    {
      id: 'war-script-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch chrome/script.js — the injected add-on loader, exposed only to Twitch origins.',
      weight: 1,
      run: () => probeFetch(ID, 'chrome/script.js'),
    },
  ],
};
